<template>
  <div id="root">
    <div :class="cssClasses">
      <component
        :is="$route.meta.layout"
        :title="title"
        :is-x-small="screen.getScreenSizeInfo.isXSmall"
        :is-large="screen.getScreenSizeInfo.isLarge"
      >
      <div class="content">
        <router-view></router-view>
      </div>
        <template #footer>
          <app-footer />
        </template>
      </component>
    </div>

    <div v-if="(store.state.loggedIn)">
      <DxDraggable>
        <div class="button-logs" style="position:fixed; bottom:10px; right:10px;">
          <DxButton
            :width="50"
            :height="50"
            hint="Log Console"
            type="normal"
            icon="columnchooser"
            styling-mode="contained"
            @click="showInfo()"
          />
        </div>
        </DxDraggable>
    </div>
    <div style="">
    <DxPopup
      v-model:visible="popupVisible"
      :drag-enabled="true"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"
      :width="800"
      :height="500"
      container=".dx-viewport"
      title="Log Console"
    >
       <DxPosition
        at="bottom right"
        my="bottom right"
        of="windows"
        collision="fit"
      />
      <DxAnimation>
        <DxShow type="slide" duration="1000" :from="{ left: 3000 }" :to="{ left: 0}" />
      </DxAnimation>
    <DxDataGrid
        :height="430"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        column-resizing-mode="next-column"
        :data-source="logDataSource">
        <DxColumn data-field="level" width="80"></DxColumn>
        <DxColumn data-field="message"></DxColumn>
        <DxColumn data-field="time" width="180" data-type="datetime" format="yyyy-MM-dd, hh:mm:ss a" :fixed="true" :sort-index="0" sort-order="desc"></DxColumn>
        <DxColumn data-field="source"></DxColumn>
        <DxSelection mode="single"/>
  
        
        <DxHeaderFilter
            :visible="true"
          />
      </DxDataGrid>
    </DxPopup>
    </div>
  </div>
</template>

<script>
//TODO: multilanguage options on root?
import AppFooter from "./components/app-footer";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import {
  getCurrentInstance,
  reactive,
  onMounted,
  onBeforeUnmount,
  computed,
  watch, 
} from "vue";
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
import { DxPopup,DxPosition,DxAnimation, DxShow} from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';

import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';

import RawDataService from './services/RawDataServiceTemplate';
import appInfo from './app-info.js';
import MqttEnfyoClient from './utils/MqttEnfyoClient';
import notify from 'devextreme/ui/notify';
import { useStore} from 'vuex';
import DxDraggable from 'devextreme-vue/draggable';
import 
  DxDataGrid, {
    DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxPager,
    DxPaging,
    DxSelection,
    DxFormat,
    DxHeaderFilter,
} from 'devextreme-vue/data-grid';

function getScreenSizeInfo() {
  const screenSizes = sizes();

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
  };
}

export default {
  components: {
    AppFooter,

    DxPopup,
    DxPosition,
    DxAnimation,
    DxShow,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxPager,
    DxPaging,
    DxSelection,
    DxFormat,
    DxHeaderFilter, 
    DxDraggable,
  },
  data(){
    return{
      popupVisible: false
    }   
  },
  setup() {
    const vm = getCurrentInstance();
    const store = useStore();
    const title = vm.proxy.$appInfo.title;
    const screen = reactive({ getScreenSizeInfo: {} });
    screen.getScreenSizeInfo = getScreenSizeInfo();
    
    function screenSizeChanged () {
      screen.getScreenSizeInfo = getScreenSizeInfo();
    }
    
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    
    loadMessages(esMessages);
    locale('en');

    onMounted(() => {
      loadLogs();
      subscribe(screenSizeChanged);
      // set timezone
      if (store.state.loggedIn){
        const systemDataService = new RawDataService('system/info');
        systemDataService.getAll().then(async res => {
          await store.dispatch('setTimezone',res[0].timezone)
        }).catch(stErrorCb);
      }
      
    });
    onBeforeUnmount(async () => {
      unsubscribe(screenSizeChanged);
      if(mqttClient){
        await mqttClient.stop()
      }
    });
    
    const cssClasses = computed(() => {
      return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
    });

    


    // Logs
    
    const influxDataService = new RawDataService(`influx`); 
    const logSrc = [];
    const logDataSource = new DataSource({ store: new ArrayStore({ key: 'time', data:logSrc }), paginate: false });
    let mqttClient = null; 
    const loadLogs = async ()=>{
      if(store.state.loggedIn){
        const logAppend = (message, level, source="rt_monitor",timestamp) => {
           let time = timestamp? new Date(timestamp).toISOString(): new Date().toISOString()
          logDataSource.store().insert({level, time: time, source, message});
          logDataSource.reload();
        };
        
        const mqttProtocol = appInfo.serverProtocol=='https:'? 'wss':'ws'; 
        const mqttUrl = `${mqttProtocol}://${appInfo.serverHostname}:${appInfo.serverPort}/mqtt`;
        const mqttOptions = {
          keepalive: 30,
          clientId: 'enfyoWebApp_' + Math.random().toString(16).substring(2, 10),
          protocolId: 'MQTT',
          protocolVersion: 4,
          clean: true,
          reconnect: true,
          reconnectInterval: 20*1000,
          reconnectPeriod: 30*1000, 
          queueQoSZero: false,
          username: store.state.user.username,
          password: store.state.user.sessionId,
        }
        const topicsArr = [
          { topic: 'json/assets/+/logs', qos: 0 },
          { topic: 'json/signalState', qos: 0 },
        ];
        
        const receiveMsg = (topic, message) => {
          try{
            const topicArr = topic.split('/');
            const messageObj = JSON.parse(message.toString());
            if(topicArr.length==4 && topicArr[0]=='json' && topicArr[1]=='assets' && topicArr[3]=='logs'){
              const assetId=topicArr[2];

              logAppend(messageObj.message, messageObj.level||'http', assetId, messageObj.timestamp);
            }
          }
          catch(err){ logAppend('MQTT message error: '+err.message, 'error'); }
        };


        try{
          //** initializes mqtt */
          mqttClient = new MqttEnfyoClient('webapp', mqttUrl, mqttOptions, topicsArr, receiveMsg);
          await mqttClient.start();
          logAppend('MQTT data streaming online', 'info');
        
          const initTime=new Date().getTime()-1000*60*60*24;
          const endTime=new Date().getTime()-1;
          influxDataService.getByKey('/mqttLogs/?dateStart='+initTime+'&dateEnd='+endTime+'&limit=100' ).then((dataInflux) =>{ for(const data of dataInflux){
              logDataSource.store().insert({level: data.service, time: data.time, source:data.deviceUid, message: data.message});
              }
          });

        }
        catch(err){
          notify('error mounting: '+err.message, "error", 5000);
        }
        
      }else{
        if(mqttClient){
          await mqttClient.stop()
        }
      }
    }

    


    watch(()=>store.state.loggedIn,async ()=>{   
        loadLogs()
    })

    return {
      title,
      screen,
      cssClasses,

      logDataSource,
      store
    };
  },
  methods: {
    showInfo() {
      this.popupVisible = true;
    },
  },
  

};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
  overflow-x:hidden
}

#root {
  height: 100%;
  
}

* {
  box-sizing: border-box;
}


.dx-tab.dx-state-focused::after {
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.dx-tabpanel.dx-state-focused > .dx-tabpanel-tabs .dx-tab.dx-tab-selected {
  box-shadow: inset 0 1px 0px #ddd, inset -1px 0, inset 1px 0 #ddd;
}
.dx-tabpanel.dx-state-focused > .dx-tabpanel-tabs .dx-tabs {
  box-shadow: inset 0 -1px #ddd, inset 0 1px, inset -1px 0, inset 1px 0 ;
}
.dx-tabpanel.dx-state-focused > .dx-tabpanel-tabs .dx-tab {
  box-shadow: inset 0 1px, inset 0 -1px #ddd;
}
.dx-tabpanel.dx-state-focused > .dx-tabpanel-tabs .dx-tabs-expanded .dx-tab:not(.dx-tab-selected):first-of-type{
  box-shadow: inset 0 -1px #ddd, inset 0 1px, inset 1px 0 ;
}
.dx-tabpanel.dx-state-focused > .dx-tabpanel-container > .dx-multiview-wrapper,
.dx-tabpanel > .dx-tabpanel-container > .dx-multiview-wrapper{
  border-color: #ffffff
}

.dx-tabpanel-tabs .dx-tabs:not(.dx-tabs-vertical) .dx-tabpanel-tab {
    max-width: none;
}

@keyframes dx-datagrid-highlight-change {
    from {
        background-color: #efefef;
    }
    50% {
        background-color: #efefef;
    }
}
.dx-datagrid-cell-updated-animation {
    animation: dx-datagrid-highlight-change 1s;
}
.dx-datagrid-row-inserted-animation {
    animation: dx-datagrid-highlight-change 1s;
}

.button-logs .dx-icon {
 font-size:25px;
 margin-top:0;
 width: 30px;
 height: 30px
}

.app {
  @import "./themes/generated/variables.base.scss";
  background-color: darken($base-bg, 5);
  display: flex;
  height: 100%;
  width: 100%;
}

.disabled-overlay{ 
  .dx-button {
  pointer-events: none; /* Evita que se puedan hacer clics en los elementos */
  opacity: 0.5; /* Reduce la opacidad para dar la apariencia de desactivado */
  filter: grayscale(100%); /* Convierte el contenido a escala de grises */
  }
  .dx-radiobutton{
  pointer-events: none; /* Evita que se puedan hacer clics en los elementos */
  opacity: 0.5; /* Reduce la opacidad para dar la apariencia de desactivado */
  filter: grayscale(100%); /* Convierte el contenido a escala de grises */
  }
  .dx-link{
  pointer-events: none; /* Evita que se puedan hacer clics en los elementos */
  opacity: 0.5; /* Reduce la opacidad para dar la apariencia de desactivado */
  filter: grayscale(100%); /* Convierte el contenido a escala de grises */
  }
  .dx-scheduler .dx-button {
  pointer-events: auto; /* Evita que se puedan hacer clics en los elementos */
  opacity: 1; /* Reduce la opacidad para dar la apariencia de desactivado */
  filter: grayscale(0%); /* Convierte el contenido a escala de grises */
  }
}


.warning-icon {
  width: 25px; /* Ajusta el tamaño del icono según tus necesidades */
  height: 25px; /* Ajusta el tamaño del icono según tus necesidades */
  background-image: url('assets/objects/warning.png'); /* Reemplaza 'ruta/a/tu/icono_de_advertencia.png' con la ruta de tu icono de advertencia */
  background-size: 25px 25px;
  background-repeat: no-repeat;
  float: right;
  margin-left:15px;
}

.warning-icon:hover::after {
  content:'You do not have sufficient permissions to make changes';
  position: absolute;
 
  transform: translate(-101%, 0);
  padding: 5px 15px 5px 15px;
  background-color: #ffcc0064; /* Color de fondo del mensaje emergente */
  color: #454545; /* Color del texto del mensaje emergente */
  border-radius: 5px;
  white-space: nowrap;
  z-index: 999;
}

.dx-state-disabled {
  pointer-events: none;
  opacity: 0.3;
}



</style>
